import { render } from "./AuthCodesResult.vue?vue&type=template&id=e965317a"
import script from "./AuthCodesResult.vue?vue&type=script&lang=js"
export * from "./AuthCodesResult.vue?vue&type=script&lang=js"

import "./AuthCodesResult.vue?vue&type=style&index=0&id=e965317a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__